export default __webpack_public_path__ + "static/media/MHL.2d8fbc15.svg";